import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { InputX, InputRed } from 'components'
import styles from './index.module.css'

const TravelSearch = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding">
				<div className="form-group search-bar">
					<InputX type="text" placeholder="회사정보를 입력해보세요." defaultValue="ㅇ" id="" />
					<i className="icon icon_search" />
				</div>
				<InputRed text="2글자 이상 키워드를 입력해주세요." show={true} />
			</div>
			<div className={`${styles["l-title"]} padding pb_20`}>최근 검색어</div>
			<div className="no-scroll pb_30" style={{ overflowX: "auto" }}>
				<ul className={`${styles["search-word"]}`}>
					<li><span>제주</span><i className="icon" /></li>
					<li><span>제주도</span><i className="icon" /></li>
					<li><span>제주도 여행</span><i className="icon" /></li>
				</ul>
			</div>
		</div>
	)
}

export default TravelSearch